import { sport, oddsTypeUOF } from 'constants/enum';

const boviktest = {
  [sport.soccer]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.soccer].live.total,
      oddsTypeUOF[sport.soccer].live.nextgoal,
      oddsTypeUOF[sport.soccer].live.three_way_live,
    ],
  },
  [sport.tennis]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.tennis].live.three_way_live,
    ],
  },
};

export default boviktest;
